import { colors, typography as typographyTokens, } from '@dixa/lib-shared-tokens';
export const hexStringToNumber = (hex) => parseInt(hex.slice(1), 16);
export const dixaColorsToNumbers = (colors) => Object.fromEntries(Object.entries(colors).map(([key, hex]) => [key, hexStringToNumber(hex)]));
export const white = 0xffffff;
export const neutral = dixaColorsToNumbers(colors.neutral);
export const blue = dixaColorsToNumbers(colors.blue);
export const red = dixaColorsToNumbers(colors.red);
export const purple = dixaColorsToNumbers(colors.purple);
export const typography = dixaColorsToNumbers(typographyTokens.color);
